module.exports = __webpack_public_path__ + "images/noPartnerLeft_26d2404.svg";